import { Fragment } from "react";
import WebLayout from "../../components/WebLayout";
import {
  WhoWeAre,
  OurImpact,
  FeaturePrograms,
  HomeFaq,
  HomeLanding,
} from "./index.js";
import Loader from "../../components/loader/Loader.jsx";
import LatestBlog from "../../pages/about/latestBlog/LatestBlog.jsx";
import Testimonials from "./testimonials/Testimonials.jsx";
import { useEffect, useState } from "react";
import { baseUrl, getHome } from "../../utils/apiData.js";
import axios from "axios";
import { Counter } from "../about/index.js";

const Home = () => {
  const [loader, setLoader] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [testimonial, setTestimonial] = useState([]);
  const [slide, setSlide] = useState([]);
  const [pageData, setPageData] = useState({});
  const [faq, setFaq] = useState([]);

  const getHomeApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getHome}`);

      if (res?.data?.success) {
        setBlogs(res?.data?.data?.blogs);
        setTestimonial(res?.data?.data?.testimonial);
        setSlide(res?.data?.data?.homeslide);
        setPageData(res?.data?.data?.homepage);
        setFaq(res?.data?.data?.faq);
      }
    } catch (error) {
      console.log(error);
    }
    setLoader(false);
  };

  useEffect(() => {
    getHomeApi();
  }, []);

  return (
    <WebLayout>
      {loader ? (
        <Loader />
      ) : (
        <div className="home_wrap">
          <HomeLanding dataList={slide} />
         
          <WhoWeAre pageData={pageData} />
          <OurImpact pageData={pageData} />
          <HomeFaq pageData={pageData} dataList={faq} />
          {testimonial?.length > 0 && <Testimonials dataList={testimonial} />}
          <LatestBlog classList="p_t p_b" dataList={blogs?.slice(0, 2)} />
        </div>
      )}
    </WebLayout>
  );
};

export default Home;
